import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TitleBar from "../titleBar";
import Box from "../box";
import { getLocalStateValue } from "../../../utils/helpers";
import InfoModal from "../infoModal";

// image imports
import ClimateEleven from "../../../assets/climate/climate_eleven.png"
import ClimateTwelve from "../../../assets/climate/climate_twelve.png"

type KlimaatProps = {
    globals?: {
        colors: {
            default: ""
        }
    },
    pageData?: {
        back_text: string,
        title: string,
        description: string,
        next_url: string,
        prev_url: string
    },
    updateAnswer?: (title: string, answer: string, url?: string) => void,
    storeAnswer?: (data: any, key: string) => void,
    modalInformation?: any
}

const Klimaat = ({ globals, pageData, updateAnswer = () => {}, storeAnswer = () => {}, modalInformation }: KlimaatProps) => {
    const [ hoverState, setHoverState ] = useState(0);
    const [ activeBox, setActiveBox ] = useState("");
    const [ modalState, setModalState ] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const localState = getLocalStateValue("31");
        if (localState) {
            setActiveBox(localState.answerNo);
        }
    }, [])

    const goBack = () => {
        navigate(getPreviousLink())
    }

    const getPreviousLink = () => {
        const localState = getLocalStateValue("28");
        if (localState) {
            if (localState.answerNo === "0") {
                return "/vraag/voor-ofachtertuin";
            }
            else {
                return "/vraag/groendak";
            }
        }
        else {
            return "/vraag/voor-ofachtertuin";
        }
    }

    const getBackText = () => {
        const localState = getLocalStateValue("28");
        if (localState) {
            if (localState.answerNo === "0") {
                return "Voor- of achtertuin";
            }
            else {
                return "Groendak";
            }
        }
        else {
            return "Voor- of achtertuin";
        }
    }

    const getImage = (answerIndex?: string) => {
        switch(answerIndex) {
            case "0":
                return ClimateTwelve;
            case "1":
                return ClimateEleven;
        }
    }

    const onClick = (answer?: string, answerIndex?: string) => {
        const question = "zonnewering";
        updateAnswer(question || "", answer || "", pageData?.next_url);
        storeAnswer({"answerNo": answerIndex, "zonnewering": answer, image: getImage(answerIndex)}, "31")
    }

    const openInformationModal = () => {
        setModalState(true);
    }

    return(
        <div className = "w-full flex justify-center box-border">
            <div className = "container mx-auto flex-col justify-center box-border px-[16px] md:px-16 lg:px-32">
                <TitleBar back_text = {getBackText()} infoColor = {globals?.colors?.default} title = {pageData?.title} description = {pageData?.description} goBack = {goBack} openInfoModal={openInformationModal} />
                <div className = "flex flex-col w-full mt-[10px] mb-[100px]">
                    <div className = "flex w-full flex-col md:flex-row">
                        <Box flex = {1} hasRightBorder text = "Ja, het wordt te warm in de zomer" hoverValue = {1} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {ClimateTwelve} answerIndex = "0" isActive = {activeBox === "0"} />
                        <Box flex = {1} hasRightBorder text = "Nee, het wordt niet te warm" hoverValue = {2} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {ClimateEleven} answerIndex = "1" isActive = {activeBox === "1"} />
                        <div className = "flex flex-1" />
                    </div>
                </div>
            </div>
            <InfoModal modalInformation = {modalInformation} isModalOpen = {modalState} closeModal = {() => setModalState(false)} />
        </div>
    )
}

export default Klimaat;